module.exports = require("./cgg.js");